import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    mapContainer: {
      marginTop: '0.7rem',
      height: '100%',
      width: '100%',
      maxHeight: '380px',
      minHeight: '380px',

      '& > div': {
        backgroundColor: '#F4F4F4',
        border: 'solid 1px #D2D2D2',
        borderRadius: 5,
        height: '100%',
      },
    },
  }),
)
